/**
 * 获取 url 搜索部分key所对应的值
 * @param {String} name 需要获取所对应值的 key
 * @param {String} urlSearch eg: ?name=Tony&id=1234 or name=Tony&id=1234
 * @return 匹配键所得到的值 or false
 */
export const getRequest = (name: string, $urlSearch?: string) => {
  let urlSearch = $urlSearch;
  if (!urlSearch) {
    [, urlSearch] = window.location.href.split('?');
  } else if (urlSearch.split('?')[1]) {
    [, urlSearch] = urlSearch.split('?');
  }
  if (urlSearch) {
    // 去除 hash 值
    [urlSearch] = String(urlSearch).split('#');
  }
  const res = new RegExp(`(^|&)${name}=([^&]*)`).exec(urlSearch);
  return !!res && res[2];
};
